import React from "react";
import { Card, Row, Col } from "react-bootstrap";

const reportsData = [
  {
    title: "Financial",
    content: ["Revenue Summary", "Revenue Breakdown", "Revenue by Plan"],
  },
  {
    title: "User activity",
    content: ["User Summary", "User Breakdown", "User by Plan"],
  },
  {
    title: "User information",
    content: ["User Demographics", "User Details"],
  },
  {
    title: "Provider Information",
    content: ["All Providers", "User Details"],
  },
  {
    title: "Request Reports",
    content: [
      "Support Request Summary",
      "Support Request Breakdown",
      "Health Nav Request",
      "Health Coach Request",
      "Change Request",
    ],
  },
  {
    title: "Appointments",
    content: ["User Demographics", "User Details"],
  },
];

const Reports = () => {
  return (
    <div className="container p-2">
      <h4>Reports</h4>
      <Row>
        {reportsData.map((report, index) => (
          <Col md={6} key={index}>
            <Card className="mb-3">
              <Card.Header>{report.title}</Card.Header>
              <Card.Body>
                <ul>
                  {report.content.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default Reports;
